import { useEffect, useState } from "react";
import { settings } from "@tumbodash/browserPackages";

interface GameEntry {
	slug: string;
	name: string;
	active: number;
}

function Admin() {
	const [games, setGames] = useState<GameEntry[]>([]);
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		fetch(`${settings.serverUrl}admin/games`)
			.then(r => r.json())
			.then(setGames)
			.catch(() => setError("Could not reach server"));
	}, []);

	async function toggle(slug: string, current: number) {
		const next = current === 1 ? 0 : 1;
		const res = await fetch(`${settings.serverUrl}admin/games/${slug}/active`, {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ active: next }),
		});
		if (res.ok) {
			setGames(prev => prev.map(g => g.slug === slug ? { ...g, active: next } : g));
		}
	}

	return (
		<div style={{
			minHeight: "100dvh",
			display: "flex",
			flexDirection: "column",
			padding: "var(--space-8) var(--space-5)",
			maxWidth: 480,
			margin: "0 auto",
			gap: "var(--space-5)",
		}}>
			<div style={{ fontSize: "1.4rem", fontWeight: 800, fontFamily: "var(--font-display)", color: "var(--text-primary)" }}>
				Game Library
			</div>

			{error && (
				<div style={{ color: "var(--color-error, #f66)", fontSize: "0.85rem" }}>{error}</div>
			)}

			<div style={{ display: "flex", flexDirection: "column", gap: "var(--space-2)" }}>
				{games.map(game => (
					<div
						key={game.slug}
						style={{
							display: "flex",
							alignItems: "center",
							justifyContent: "space-between",
							padding: "var(--space-4)",
							borderRadius: "var(--radius-md)",
							background: "var(--bg-elevated)",
							border: "1px solid var(--border)",
						}}
					>
						<span style={{
							fontWeight: 600,
							fontSize: "0.95rem",
							color: game.active ? "var(--text-primary)" : "var(--text-muted)",
							fontFamily: "var(--font-ui)",
						}}>
							{game.name}
						</span>

						<button
							onClick={() => toggle(game.slug, game.active)}
							style={{
								width: 48,
								height: 26,
								borderRadius: 13,
								border: "none",
								cursor: "pointer",
								background: game.active ? "var(--accent)" : "var(--bg-surface, #333)",
								position: "relative",
								transition: "background 150ms",
								flexShrink: 0,
							}}
						>
							<span style={{
								position: "absolute",
								top: 3,
								left: game.active ? 25 : 3,
								width: 20,
								height: 20,
								borderRadius: "50%",
								background: "#fff",
								transition: "left 150ms",
							}} />
						</button>
					</div>
				))}
			</div>
		</div>
	);
}

export default Admin;
